import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import AlgorithmService from '../../../../service/auction/AlgorithmService';
import {
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
} from '../../../components/modal/Modal.style';

interface Props {
  createPattern: () => Promise<number>;
  getResult: (iidx: number) => Promise<any>;
  onClose: () => void;
  onDone: () => void;
  onSearchRecommend: (patternInfo: any) => void;
}
const SaveModal = ({
  createPattern,
  getResult,
  onClose,
  onDone,
  onSearchRecommend,
}: Props) => {
  const navigate = useNavigate();
  const [patternName, setPatternName] = useState('');

  const savePattern = async () => {
    try {
      const iidx = await createPattern();
      if (!iidx) return 0;

      const nameToSave = patternName.trim() || `나만의 알고리즘 ${iidx}`;

      const res = await AlgorithmService.saveAlgorithm(iidx, {
        name: nameToSave,
      });

      if (res.status === 'success') {
        return res.data[0].algorithm_idx;
        // // const patternInfo = await getResult(res.data[0].algorithm_idx);
        // // await onSearchRecommend(patternInfo);
        // // onClose();
      }
      return 0;
    } catch (error) {
      console.log(error);
      return 0;
    }
  };

  const handleSaveButton = async () => {
    const res = await savePattern();
    onClose();
    if (!res) return;
    onDone();
  };

  const handleSearchButton = async () => {
    const res = await savePattern();
    if (!res) {
      onClose();
      return;
    }
    const patternInfo = await getResult(res);
    await onSearchRecommend(patternInfo);
    onClose();
  };

  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>나만의 알고리즘 저장</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Content>
        <Label>나만의 알고리즘명</Label>
        <InputContainer>
          <InputBox>
            <Input
              type="text"
              placeholder="예) 임대수익용 아파트 알고리즘"
              value={patternName}
              onChange={(e) => setPatternName(e.target.value)}
            />
          </InputBox>
        </InputContainer>
        <GuideBox>
          <img src="/assets/images/icon/info-gray.svg" alt="" />{' '}
          <span>알고리즘 이름 미입력 시 자동으로 저장됩니다.</span>
        </GuideBox>
      </Content>
      <ButtonBox>
        <CancleButton onClick={handleSaveButton}>저장</CancleButton>
        <ConfirmButton onClick={handleSearchButton}>
          추천물건 검색
        </ConfirmButton>
      </ButtonBox>
    </BottomModal>
  );
};

export default SaveModal;

const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const Label = styled.div`
  color: #616161;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const InputBox = styled.div`
  display: flex;
  height: 50px;
  padding: 12px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #f5f7fa;
`;

const Input = styled.input`
  flex: 1 0 0;
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.8px;

  &::placeholder {
    color: rgba(158, 165, 181, 0.6);
  }
`;

const GuideBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const ButtonBox = styled.div`
  padding: 16px 16px 40px 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid #e5e8ea;
`;

const Button = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 12px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  flex: 1 0 0;
`;

const CancleButton = styled(Button)`
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
`;

const ConfirmButton = styled(Button)`
  background-color: #008aff;
  color: #fff;
`;
